export default __webpack_public_path__ + "RobotoCondensed-RegularItalic.aca8cfe6a0fd2abecaa6e21a19f66eba.ttf";